import { useState } from 'react';
import { useBlockedUsers } from '../context/BlockedUsersProviderIPFS';

export const useBlockedUserCheck = () => {
  const { isUserBlocked } = useBlockedUsers();
  const [blockedDialogOpen, setBlockedDialogOpen] = useState(false);
  const [blockedUserAddress, setBlockedUserAddress] = useState('');
  const [blockedAction, setBlockedAction] = useState('');

  const checkUserBlocked = (userAddress, action = 'perform this action') => {
    if (isUserBlocked(userAddress)) {
      setBlockedUserAddress(userAddress);
      setBlockedAction(action);
      setBlockedDialogOpen(true);
      return true; // User is blocked
    }
    return false; // User is not blocked
  };

  const closeBlockedDialog = () => {
    setBlockedDialogOpen(false);
    setBlockedUserAddress('');
    setBlockedAction('');
  };

  return {
    checkUserBlocked,
    blockedDialogOpen,
    blockedUserAddress,
    blockedAction,
    closeBlockedDialog
  };
};

export default useBlockedUserCheck;
